import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryQuestions'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryQuestionsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryQuestionsStore",
			variables: false,
		})
	}
}

export async function load_InventoryQuestions(params) {
  await initClient()

	const store = new InventoryQuestionsStore()

	await store.fetch(params)

	return {
		InventoryQuestions: store,
	}
}
